import configApi from "../configApi";

const sectionBaseURL = "/api/campaign/campaigns";

const apiCampaign = {
  index: async (page = 1, interestFilter = null) => {
    let url = `${sectionBaseURL}/?page=${page}`;

    if (interestFilter) {
      url = `${sectionBaseURL}/?page=${page}&interests=${interestFilter}`;
    }

    return await configApi.get(url);
  },

  detail: async campaignID => {
    let url = `${sectionBaseURL}/${campaignID}/`;
    return await configApi.get(url);
  },

  subscribe: async campaignID => {
    let url = `${sectionBaseURL}/${campaignID}/subscribe/`;

    return await configApi.post(url);
  }
};

export default apiCampaign;
